import React, { useState } from "react";
import PdfTemplate, { PdfColorPallete } from "../../../../common/PdfTemplate";
import { Box } from "@material-ui/core";
import styles from "./styles.module.css";

const PreviewInvoice = ({ InvoiceData = {} }) => {
  const [invStyle, setInvStyle] = useState(
    localStorage.getItem("invoiceStyle") || "style1",
  );
  const [invTheme, setInvTheme] = useState(
    localStorage.getItem("invoiceColor") || PdfColorPallete?.[0],
  );

  return (
    <Box className={styles.previewStickyWrap}>
      <Box className={styles.previewRoot}>
        <Box className={styles.a4Frame}>
          <PdfTemplate
            ReceiptData={InvoiceData}
            invStyle={invStyle}
            invTheme={invTheme}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PreviewInvoice;
